// src/pages/AppliAdmin/ContactForm/components/ContactFiltersBar.jsx
import React from "react";
import {
  FaCheckDouble,
  FaDownload,
  FaFilter,
  FaSearch,
  FaTimes,
} from "react-icons/fa";

const INPUT =
  "w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-800 outline-none transition placeholder:text-slate-400 focus:border-indigo-400 focus:ring-4 focus:ring-indigo-100 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:focus:border-indigo-500 dark:focus:ring-indigo-950";

export default function ContactFiltersBar({
  q,
  setQ,
  readFilter,
  setReadFilter,
  dateFrom,
  setDateFrom,
  dateTo,
  setDateTo,
  sort,
  setSort,
  onExport,
  onMarkAllRead,
  onResetFilters,
}) {
  return (
    <section className="rounded-[28px] border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900 sm:p-5">
      <div className="mb-4 flex flex-col gap-2 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-indigo-50 px-3 py-1 text-xs font-bold uppercase tracking-wide text-indigo-700 dark:bg-indigo-950/70 dark:text-indigo-300">
            <FaFilter />
            Filtres
          </div>

          <h2 className="mt-2 text-xl font-bold text-slate-900 dark:text-white">
            Rechercher et organiser
          </h2>
        </div>

        <div className="flex flex-wrap gap-2">
          <ActionButton onClick={onMarkAllRead} tone="success">
            <FaCheckDouble />
            Tout marquer lu
          </ActionButton>

          <ActionButton onClick={onExport} tone="primary">
            <FaDownload />
            Export CSV
          </ActionButton>

          <ActionButton onClick={onResetFilters} tone="neutral">
            <FaTimes />
            Réinitialiser
          </ActionButton>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-3 lg:grid-cols-12">
        <div className="relative lg:col-span-4">
          <FaSearch className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
          <input
            type="search"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Nom, email, contenu du message..."
            className={`${INPUT} pl-11`}
          />
        </div>

        <select
          value={readFilter}
          onChange={(e) => setReadFilter(e.target.value)}
          className={`${INPUT} lg:col-span-2`}
        >
          <option value="all">Tous les statuts</option>
          <option value="unread">Non lus</option>
          <option value="read">Lus</option>
        </select>

        <select
          value={sort}
          onChange={(e) => setSort(e.target.value)}
          className={`${INPUT} lg:col-span-2`}
        >
          <option value="date_desc">Plus récents</option>
          <option value="date_asc">Plus anciens</option>
          <option value="name_az">Nom A → Z</option>
          <option value="name_za">Nom Z → A</option>
        </select>

        <input
          type="date"
          value={dateFrom}
          onChange={(e) => setDateFrom(e.target.value)}
          className={`${INPUT} lg:col-span-2`}
          title="Date de début"
        />

        <input
          type="date"
          value={dateTo}
          onChange={(e) => setDateTo(e.target.value)}
          className={`${INPUT} lg:col-span-2`}
          title="Date de fin"
        />
      </div>
    </section>
  );
}

function ActionButton({ children, onClick, tone = "neutral" }) {
  const tones = {
    primary:
      "bg-indigo-600 text-white hover:bg-indigo-700 dark:bg-indigo-500 dark:hover:bg-indigo-600",
    success:
      "bg-emerald-600 text-white hover:bg-emerald-700 dark:bg-emerald-500 dark:hover:bg-emerald-600",
    neutral:
      "bg-slate-100 text-slate-700 hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-100 dark:hover:bg-slate-700",
  };

  return (
    <button
      type="button"
      onClick={onClick}
      className={`inline-flex items-center justify-center gap-2 rounded-2xl px-4 py-2.5 text-sm font-bold transition hover:-translate-y-0.5 ${tones[tone]}`}
    >
      {children}
    </button>
  );
}